import React from 'react';
import PropTypes from 'prop-types';
import { getClickAttrs } from '../Analytics/gtag';
import styles from './popOverMenu.scss';

class PopOverMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuShowed: false,
            displayMenuBelowAnchor: true,
        };
        this.handleAchorClick = this.handleAchorClick.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.menuItemClick = this.menuItemClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('touchend', this.handleClickOutside, false);
    }

    componentDidUpdate() {
        const { selectedValue, menuItems } = this.props;
        if (this.state.isMenuShowed && selectedValue) {
            const menu = menuItems.find(item => item.divisionName === selectedValue || item.value === selectedValue);
            const list = document.getElementById('list');
            if (menu) {
                const element = document.getElementById(`item${menu.value}`);
                if (list.scrollHeight > list.clientHeight && element && list) {
                    list.scrollTop = element.offsetTop;
                }
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchend', this.handleClickOutside, false);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleAchorClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        let showBelow = true;
        if (ev.nativeEvent.clientY > (2 * window.innerHeight / 3)) {
            showBelow = false;
        }
        const { alignLeft } = this.props;
        this.setState({
            isMenuShowed: true,
            displayMenuBelowAnchor: showBelow,
            alignLeft,
        });
    }

    menuItemClick(menuItem) {
        return (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            if (this.props.onSelected) {
                this.props.onSelected(menuItem, ev);
            }
            this.setState({
                isMenuShowed: false,
            });
        };
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isMenuShowed) {
            event.stopPropagation();
            event.preventDefault();
            this.setState({
                isMenuShowed: false,
            });
        }
    }

    render() {
        const { selectedValue, 'data-testid': dataTestId } = this.props;
        const List = () => {
            return (
                <div
                    id="list"
                    className={`popovermenu-list ${this.props.popOverMenuClass ? this.props.popOverMenuClass : ''} `}
                    data-testid={dataTestId && `${dataTestId}.list`}
                >
                    {this.props.menuItems && this.props.menuItems.map((menuItem) => {
                        const getMenuItemClassName = (menuItem?.divisionName && selectedValue && selectedValue === menuItem.divisionName) || (selectedValue && menuItem.value === selectedValue) ? 'text-blue' : '';
                        return (
                            (menuItem && (typeof menuItem.show === 'undefined' || (typeof menuItem.show !== 'undefined' && menuItem.show !== false)))
                                ? (
                                    <div
                                        id={`item${menuItem.value}`}
                                        key={menuItem.value}
                                        className="menu-item"
                                        onClick={this.menuItemClick(menuItem)}
                                        data-testid={dataTestId && `${dataTestId}.item-${menuItem.value}`}
                                        {...getClickAttrs({
                                            category: menuItem.clickCategory,
                                            context: menuItem.clickContext,
                                            location: menuItem.clickLocation,
                                        })}
                                    >
                                        {menuItem.playing ? (
                                            <div className={`draw-label`} data-testid={dataTestId && `${dataTestId}.item-${menuItem.value}.label`}>
                                                {menuItem.label}
                                                <div className={`tag tag-green tag-xs user-status`} data-testid={dataTestId && `${dataTestId}.item-${menuItem.value}.playing-tag`}>Playing</div>
                                            </div>
                                        ) : (
                                            <div className={getMenuItemClassName} data-testid={dataTestId && `${dataTestId}.item-${menuItem.value}.label`}>
                                                {menuItem.label}
                                            </div>
                                        )}
                                    </div>
                                )
                                : null
                        );
                    })}
                </div>
            );
        };

        return (
            <div className={`${styles.popOverMenu} ${this.props.popOverMenuClass ? this.props.popOverMenuClass : ''} ${this.props.children ? '' : styles.ellipsis}`} data-testid={dataTestId || undefined}>
                <div
                    className={`popovermenu-anchor ${this.props.anchorClass ? this.props.anchorClass : ''}`}
                    onClick={this.handleAchorClick}
                    data-testid={dataTestId && `${dataTestId}.anchor`}
                >
                    {this.props.children ? this.props.children : <span className={`far ${this.props.horizontalEllipsis ? 'fa-ellipsis-h' : 'fa-ellipsis-v'}`} />}
                </div>
                {this.state.isMenuShowed && (
                    <div className="anchor-click-disabler" />
                )}
                <div
                    className={`menu-container ${this.state.displayMenuBelowAnchor ? 'below-anchor' : 'above-anchor'} ${this.state.alignLeft ? 'align-left' : 'align-right'} ${this.props.mobileAlignLeft} `}
                    ref={this.setWrapperRef}
                >
                    {this.state.isMenuShowed && (
                        <List />
                    )}
                </div>
            </div>

        );
    }
}

PopOverMenu.propTypes = {
    mobileAlignLeft: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    menuItems: PropTypes.arrayOf(PropTypes.any).isRequired,
    selectedValue: PropTypes.string,
    alignLeft: PropTypes.bool,
    onSelected: PropTypes.func.isRequired,
    popOverMenuClass: PropTypes.string,
    anchorClass: PropTypes.string,
    horizontalEllipsis: PropTypes.bool,
    children: PropTypes.node,
    'data-testid': PropTypes.string,
};

PopOverMenu.defaultProps = {
    mobileAlignLeft: false,
    selectedValue: '',
    alignLeft: false,
    popOverMenuClass: '',
    anchorClass: '',
    horizontalEllipsis: false,
    children: null,
    'data-testid': null,
};

export default PopOverMenu;
